var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1198_14110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.75C14.7583 18.75 14.0333 18.5301 13.4166 18.118C12.7999 17.706 12.3193 17.1203 12.0355 16.4351C11.7516 15.7498 11.6774 14.9958 11.8221 14.2684C11.9668 13.541 12.3239 12.8728 12.8484 12.3484C13.3728 11.8239 14.041 11.4668 14.7684 11.3221C15.4958 11.1774 16.2498 11.2516 16.9351 11.5355C17.6203 11.8193 18.206 12.2999 18.618 12.9166C19.0301 13.5333 19.25 14.2583 19.25 15C19.2489 15.9942 18.8534 16.9474 18.1504 17.6504C17.4474 18.3534 16.4942 18.7489 15.5 18.75ZM15.5 12.5C15.0055 12.5 14.5222 12.6466 14.1111 12.9213C13.7 13.196 13.3795 13.5865 13.1903 14.0433C13.0011 14.5001 12.9516 15.0028 13.048 15.4877C13.1445 15.9727 13.3826 16.4181 13.7322 16.7678C14.0819 17.1174 14.5273 17.3555 15.0123 17.452C15.4972 17.5484 15.9999 17.4989 16.4567 17.3097C16.9135 17.1205 17.304 16.8 17.5787 16.3889C17.8534 15.9778 18 15.4945 18 15C17.9993 14.3372 17.7356 13.7017 17.2669 13.2331C16.7983 12.7644 16.1628 12.5007 15.5 12.5Z",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.74375L6.38125 8.125L5.5 9.00625L8 11.5062L12.375 7.13125L11.4938 6.25L8 9.74375Z",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 15C8.01387 15 6.8055 14.6334 5.77769 13.9467C4.74988 13.2599 3.9488 12.2838 3.47576 11.1418C3.00271 9.99974 2.87894 8.74307 3.1201 7.53069C3.36125 6.31831 3.95651 5.20466 4.83059 4.33059C5.70466 3.45651 6.81831 2.86125 8.03069 2.6201C9.24307 2.37894 10.4997 2.50271 11.6418 2.97576C12.7838 3.4488 13.7599 4.24988 14.4467 5.27769C15.1334 6.3055 15.5 7.51387 15.5 8.75H16.75C16.75 7.26664 16.3101 5.8166 15.486 4.58323C14.6619 3.34986 13.4906 2.38856 12.1201 1.82091C10.7497 1.25325 9.24168 1.10472 7.78683 1.39411C6.33197 1.6835 4.9956 2.39781 3.9467 3.4467C2.89781 4.4956 2.1835 5.83197 1.89411 7.28683C1.60472 8.74168 1.75325 10.2497 2.32091 11.6201C2.88856 12.9906 3.84986 14.1619 5.08323 14.986C6.3166 15.8101 7.76664 16.25 9.25 16.25V15Z",
    fill: "#176318"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1198_14110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.21da81795506c65df68d84c06312c8d7.svg";
export { ForwardRef as ReactComponent };